// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const FoodBiotin = {
  productCode: "SBOVZ-SBC",
  productName: "Food Biotin",
  ingredients: "De-oiled Sunflower seed kernel cake",
  overview:"Food Biotin is a hydrolyzed extract blend from an eco-innovative high-purity process as it relies on a sustainable vegetable oil seed source for biologically active and bioavailable form of Biotin. ",
  assay:"Natural Food Biotin 2 %",
  coNutrients:"Sunflower seeds contain sulfur-rich proteins, which contribute to muscular and skeletal cell development. Sunflower seeds also contribute to Vitamin E, which protects lipids, proteins and DNA against oxidative damages. Incidental nutrients include natural dietary fiber, zinc, selenium and magnesium (not a claim). ",
  studies:" Comprehensive Stability studies, comparative studies with synthetic Biotin.",
  benefits:"Biotin is involved in important pathways such as gluconeogenesis, fatty acid synthesis and amino acid catabolism. Biotin regulates that catabolic enzyme propionyl-CoA carboxylase at the post-transcriptional level and holo-carboxylase synthase is regulated at the transcriptional level.  Biotin as cofactor is required for carboxylase enzymes, keratin production, gluconeogenesis, fatty acid synthesis, and amino acid catabolism and maintenance of normal mucous membranes. ",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/FoodBiotin/FB-1.png",
        "images/Portfolio/OrgavitazForDeficiencies/FoodBiotin/FB-2.png",
    "images/Portfolio/OrgavitazForDeficiencies/FoodBiotin/FB-3.png",



  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default FoodBiotin;
